import React from "react";
import {
  ArcDroneMarker,
  ArcPolyline,
} from "@src/core/controllers";
import destionation from '@src/assets/destination.svg';
import { arcMissionOrderPath } from "@src/core/extensions";
import { ErrorMapProps } from "./types";
import { Marker } from "@react-google-maps/api";

const ErrorMap: React.FC<ErrorMapProps> = (props) => {
  const { order } = props;

  return (
    <React.Fragment>
      <ArcPolyline.error path={arcMissionOrderPath(order)} />

      {order.orders.map((o: any) => {
        const lat = Number(o.deliveryLocation.latitude);
        const lng = Number(o.deliveryLocation.longitude);

        if (isNaN(lat) || isNaN(lng)) return null;

        return (
          <Marker 
            key={o.id}
            position={{ lat,  lng }} 
            icon={{ 
              url: destionation,  
              scaledSize: new window.google.maps.Size(100, 50),
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(17, 44),  
            }} />
        );
      })}

      {order.drone && order.drone.latitude && order.drone.longitude && (
        <ArcDroneMarker.error
          position={{
            lat: Number(order.drone.latitude),
            lng: Number(order.drone.longitude),
          }}
        />
      )}
    </React.Fragment>
  );
};

export default ErrorMap;
